import React from 'react';

const Welcome = () => {
    return (
        <div className='h-screen w-full flex justify-center '>
            <div className=' md:mt-10'>
                <h2 className=' text-5xl text-primary font-semibold uppercase pl-2'>Welcome to your Dashboard</h2>
                <p className='pl-2 text-center'>You are looking for dashboard</p>
            </div>
        </div>
    );
};

export default Welcome;